import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'

const GiftItem = ({ gift, handleAddGift }) => {
    return <div className="happy-cart__item happy-cart_grid happy-cart_grid_gift" data-product-id={ gift.ID }>
        <div className="happy-cart__item-td happy-cart__item-td_name">
            <div className="happy-cart__item-td-image">
                <a href={ gift.DETAIL_PAGE_URL } className="happy-cart__item-td-image-link" style={{ backgroundImage : `url( ${ gift.PREVIEW_PICTURE } )` }}></a>
            </div>
            <div className="happy-cart__item-td-content">
                <div className="happy-cart__item-td-title">
                    <a href={ gift.DETAIL_PAGE_URL } className="happy-cart__item-td-title-link">{ gift.NAME }</a>
                </div>
            </div>
        </div>
        
        <div className="happy-cart__item-td happy-cart__item-td_price">
            
        </div>

        <div className="happy-cart__item-td happy-cart__item-td_quantity">
            
        </div>

        <div className="happy-cart__item-td happy-cart__item-td_summary">
            <div className="happy-cart__item-td-discount-percent">
                <span>Подарок</span>
            </div>
        </div>

        <div className="happy-cart__item-td happy-cart__item-td_actions happy-cart__item-td_actions-gift">
            <button className="button button_buy button-add-gift" onClick={ handleAddGift.bind(this, gift) }>Выбрать подарок</button>
        </div>
    </div>
}

export default GiftItem